<template>
  <v-row align-center>
    <v-flex pr-2>
      <BookingLocationInput
        @locationChanged="pickupLocationUpdated($event)"
        v-model="pickupLocation"
        label="Pickup Location"
        id="pickup"
        :singleLineField="false"
        :soloField="false"
        :flatField="true"
        :soloInvertedField="true"
        backgroundColour
      />
    </v-flex>
    <h4 class="nobold">to</h4>
    <v-flex pl-2>
      <BookingLocationInput
        @locationChanged="destinationLocationUpdated($event)"
        v-model="destinationLocation"
        label="Destination"
        id="destination"
        :singleLineField="false"
        :soloField="false"
        :flatField="true"
        :soloInvertedField="true"
        backgroundColour
      />
    </v-flex>
  </v-row>
</template>

<script>
import BookingLocationInput from "@/components/widget/input/BookingLocationInput.vue";

import moment from "moment";
import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "cost_estimate",
  components: {
    BookingLocationInput
  },
  props: {
    rideTypes: Array
  },
  data: function() {
    return {
      pickupLocation: {},
      destinationLocation: {}
    };
  },
  methods: {
    pickupLocationUpdated: function(loc) {
      this.pickupLocation = loc;
    },
    destinationLocationUpdated: function(loc) {
      this.destinationLocation = loc;
    },
    /*
    getEstimate: function(rideTypeID) {
      //TODO move request over to booking controller when merged, change time format to use "/"
      let url = `https://intern.cabmyride.com/dispatch/api/customer/v2/getCostEstimateForRideType`;
      return axios.get(url, {
        params: {
          pickupLocation: this.pickupLocation.id,
          destinationLocation: this.pickupLocation.id,
          pickupTime: moment().format("YYYY/MM/DD HH:mm"),
          rideTypeID: rideTypeID
        }
      });
    },
    getEstimate: async function() {
      let self = this;

      let estimateRequests = [];
      this.rideTypes.forEach(function(rideType) {
        estimateRequests.push(self.getEstimate(rideType.id));
      })

      axios.all(estimateRequests).then(function(estimates) {
        console.log(estimates);
      });
    },
    */
    getEstimate: async function() {
      this.$emit("loading", true);
      let self = this;
      let url = `${this.$store.state.apiUrl}/booking/getCostEstimate`;
      await axios
        .get(url, {
          params: {
            pickupLocation: this.pickupLocation.id,
            destinationLocation: this.destinationLocation.id
          }
        })
        .then(function(response) {
          console.log(response.data);
          if (response.data.costs) {
            let estimates = {};
            response.data.costs.forEach(function(rideType) {
              estimates[rideType.id] = rideType.estimate;
            });
            console.log(estimates);
            self.$emit("estimates", estimates);
          }
        })
        .catch(function(error) {
          self.emit("loading", false);
        });
    },
    objectEmpty: function(object) {
      return !object || Object.keys(object).length === 0;
    }
  },
  watch: {
    pickupLocation: function() {
      if (
        !this.objectEmpty(this.pickupLocation) &&
        !this.objectEmpty(this.destinationLocation)
      ) {
        this.getEstimate();
      }
    },
    destinationLocation: function() {
      if (
        !this.objectEmpty(this.pickupLocation) &&
        !this.objectEmpty(this.destinationLocation)
      ) {
        this.getEstimate();
      }
    }
  }
};
</script>

<style>
.nobold {
  font-weight: normal;
}
.make-small {
  transform: scale(0.8);
  transform-origin: left;
}
</style>